export const SCREEN_TINY = "@media screen and (max-width: 512px)"
export const SCREEN_NOT_TINY = "@media not screen and (max-width: 512px)"

export const SCREEN_SMALL = "@media screen and (max-width: 1024px)"
export const SCREEN_NOT_SMALL = "@media not screen and (max-width: 1024px)"
